import { useSyncExternalStore } from 'react';
import { currencyCode } from '../utils/currencySign';

export let stripeGlobal = null;

export const stripeShared = () => {
    if (!stripeGlobal) return null;
    return stripeGlobal;
};

export const setStripeKey = (key) => {
    if (typeof window.Stripe !== 'function') {
        console.warn('Stripe.js not loaded yet, deferring initialization');
        waitForStripe(key);
        return;
    }
    console.log("Set stripe key: ", key);
    stripeGlobal = window.Stripe(key);
    paymentStore.setState({ isStripeReady: true });
    checkAvailability();
};

function waitForStripe(key, maxWaitMs = 10000) {
    const start = Date.now();
    const interval = setInterval(() => {
        if (typeof window.Stripe === 'function') {
            clearInterval(interval);
            console.log("Set stripe key (deferred): ", key);
            stripeGlobal = window.Stripe(key);
            paymentStore.setState({ isStripeReady: true });
            checkAvailability();
        } else if (Date.now() - start > maxWaitMs) {
            clearInterval(interval);
            console.warn('Stripe.js failed to load within timeout');
        }
    }, 200);
}

export const solidgateApplePayContainerRef = { current: null };
export const solidgateGooglePayContainerRef = { current: null };

let state = {
    isStripeReady: false,
    isChecking: false,
    isApplePayAvailable: false,
    isGooglePayAvailable: false,
    isStripeCardAvailable: true,
    isPaypalAvailable: true,
    isProcessing: false,
    isSolidgateLoading: false,
    isSolidgateApplePayMounted: false,
    isSolidgateGooglePayMounted: false,
    isSolidgateAppleWalletResolved: false,
    isSolidgateGoogleWalletResolved: false,
    isSolidgateWalletProcessing: false,
};

const listeners = new Set();

function emit() {
    for (const l of listeners) l();
}

export const paymentStore = {
    getState() { return state; },
    setState(patch) {
        state = { ...state, ...patch };
        emit();
    },
    subscribe(listener) {
        listeners.add(listener);
        return () => listeners.delete(listener);
    },
};

export function usePaymentStore() {
    return useSyncExternalStore(
        paymentStore.subscribe,
        paymentStore.getState,
        paymentStore.getState
    );
}

const checkAvailability = async () => {
    paymentStore.setState({ isChecking: true });

    try {

        const paymentRequest = stripeGlobal.paymentRequest({
            country: 'US',
            currency: currencyCode().toLowerCase(),
            total: { label: '1 Rino Subscription', amount: 2999 },
            requestPayerName: false,
            requestPayerEmail: false,
        });

        const result = await paymentRequest.canMakePayment();

        paymentStore.setState({
            isChecking: false,
            isApplePayAvailable: result && result.applePay,
            isGooglePayAvailable: result && result.googlePay,
            isStripeCardAvailable: true,
            isPaypalAvailable: true,
        });
    } catch (error) {
        paymentStore.setState({
            isChecking: false,
            isApplePayAvailable: false,
            isGooglePayAvailable: false,
            isStripeCardAvailable: true,
            isPaypalAvailable: true,
        });
    }
};
